export default __webpack_public_path__ + "static/media/uploadButton.57972d7a.svg";